export const NAME = 'affixElements';
